import DashboardSidebar from "../../components/dashboard/Sidebar";
import DashboardTopbar from "../../components/dashboard/Topbar";

export default function DashboardLayout({ children }) {
    return (
        <div className="flex bg-gray-100">
            {/* SIDEBAR */}
            <DashboardSidebar />

            {/* MAIN */}
            <div className="flex-1">
                <DashboardTopbar />

                <div className="p-6">
                    {children}
                </div>
            </div>
        </div>
    );
}
